class CountAction {
    constructor(targetObj, params){
        if(!targetObj) return;
        this.settings = {
            ...this.defaults(),
            ...params,
        }
        this.targetObj = targetObj;
        this.chkObjs = targetObj.querySelectorAll('input[type="checkbox"]');
        this.init();
    }

    defaults(){
        return {
        }
    }

    init(){
        this.chkObjs.forEach((obj) => {
            obj.addEventListener('change', (e) => {
                setTimeout(() => {
                    this.count();
                }, 100);
            });
        });

        // ブラウザバック対応
        setTimeout(() => {
            this.count();
        }, 400);
    }

    count() {
        let countAll = 0;
        this.chkObjs.forEach((obj) => {
            if(obj.closest('[data-child]') == null) return; // 親要素はスキップ
            // 子要素のカウント数を集計
            if (obj.checked) {
                let count = Number(obj.closest('label').querySelector('[data-count]').dataset.count);
                countAll += Number(count);
            }
        });
        this.targetObj.dispatchEvent(new CustomEvent('countChange', { detail: { count: countAll } }));
    }

    on(eventName, callback) {
        this.targetObj.addEventListener(eventName, function (e) {
            callback(e.detail);
        });
    }
}

export default CountAction;
